import { z } from 'zod';

/**
 * Runtime-validated environment. Importing this module fails loudly at startup
 * when configuration is missing or malformed, instead of surfacing later as an
 * inscrutable network error.
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url('VITE_API_BASE_URL must be an absolute URL'),
  VITE_APP_VERSION: z.string().default('1.0'),
  VITE_PUBLIC_ORIGIN: z.string().url().optional(),
});

const parsed = envSchema.safeParse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/v1',
  VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
  VITE_PUBLIC_ORIGIN: import.meta.env.VITE_PUBLIC_ORIGIN,
});

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(`Invalid environment configuration:\n${issues}`);
}

export const env = {
  apiBaseUrl: parsed.data.VITE_API_BASE_URL.replace(/\/+$/, ''),
  appVersion: parsed.data.VITE_APP_VERSION,
  publicOrigin: parsed.data.VITE_PUBLIC_ORIGIN ?? window.location.origin,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
